import { styled } from "styled-components";
const ToolbarBackground = styled("div")(({ theme }) => ({
  backgroundColor: theme.colors.gray2.hex,
  borderBottom: `1px solid ${theme.borderColor}`
}));
export {
  ToolbarBackground
};
